import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@navikt/ds-react";
import type { ReactElement } from "react";
import CircledIcon from "./CircledIcon";
interface Props {
  icon: ReactElement;
  children: ReactElement;
  displaySkeleton?: boolean;
}
export const IconRow = t0 => {
  const $ = _c(6);
  const {
    icon,
    displaySkeleton: t1,
    children
  } = t0;
  const displaySkeleton = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== displaySkeleton || $[1] !== icon) {
    t2 = displaySkeleton ? <div className="hidden sm:flex"><Skeleton variant="circle" width={60} height={60} /></div> : <CircledIcon className="hidden sm:flex" icon={icon} />;
    $[0] = displaySkeleton;
    $[1] = icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div className="flex flex-row gap-4">{t2}{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};